/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import {
  deletePmo,
  retrievePmos,
  savePmoFailure,
  savePmoSuccess,
} from '@store/scenario/pmo/pmo-slice';

export const deletePmoEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) => action$.pipe(
  ofType(deletePmo.type),
  concatMap((action: PayloadAction<number>) => from(dependencies.pmoGateway.delete(action.payload)).pipe(
    concatMap(() => of(savePmoSuccess(), retrievePmos())),
    catchError(() => of(savePmoFailure('Failed to delete PMO'))),
  )),
);

